import { ChangeEvent, ClipboardEvent, FormEvent, KeyboardEvent } from 'react';

import useCreateNewRoomDataContext from 'modules/CreateNewRoomModal/CreateNewRoomDataProvider/useCreateNewRoomDataContext';

import { UnitsEnum } from '../utils';

const FORBIDDEN_SYMBOLS = ['e', 'E', '+', '-', ',', '.'];

const useCustomReminder = (reminderIndex: number) => {
  const {
    roomForm: { trigger, watch, setValue },
  } = useCreateNewRoomDataContext();

  const reminderEnabledKey = `reminders.${reminderIndex}.enabled` as const;
  const reminderAmountKey = `reminders.${reminderIndex}.amount` as const;
  const reminderUnitKey = `reminders.${reminderIndex}.unit` as const;

  const remindersWatch = watch('reminders');
  const isEnabledRemindersLimitReached = remindersWatch.filter(({ enabled }) => enabled).length >= 3;

  const handleInputChange =
    (onChange: (value: number) => void) =>
    ({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
      if (!value) setValue(reminderEnabledKey, false, { shouldDirty: true });
      if (value && value !== '0' && !isEnabledRemindersLimitReached) {
        setValue(reminderEnabledKey, true, { shouldDirty: true });
      }

      trigger('reminders');
      onChange(Number(value));
    };

  const handleDropDownChange = (onChange: (unit: UnitsEnum) => void) => (unit: UnitsEnum) => {
    trigger('reminders');
    onChange(unit);
  };

  const handleInputKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (FORBIDDEN_SYMBOLS.includes(e.key)) e.preventDefault();
  };

  const handlePaste = (e: ClipboardEvent<HTMLInputElement>) => {
    const pastedValue = e.clipboardData.getData('text');
    if (FORBIDDEN_SYMBOLS.some((sym) => pastedValue.includes(sym))) e.preventDefault();
  };

  const handleCheckboxChange =
    (onChange: (event: FormEvent<HTMLDivElement>) => void) => (event: FormEvent<HTMLDivElement>) => {
      trigger('reminders');
      onChange(event);
    };

  return {
    reminderEnabledKey,
    reminderAmountKey,
    reminderUnitKey,
    handleInputChange,
    handleDropDownChange,
    handleInputKeyDown,
    handleCheckboxChange,
    handlePaste,
  };
};

export default useCustomReminder;
